import { useMemo } from 'react';
import { useGameStore } from '../../core/store';
import { skillBoards } from '../../data/skillBoards';
import { SkillCard } from './SkillCard';

/**
 * Max 4 boards visible — previous · current · next · next+1.
 * Keeps skill walls populated without mounting all 8.
 */
const PRELOAD_M = 6.5;

function getVisibleBoardIndices(runnerZ: number): number[] {
  const n = skillBoards.length;
  if (n === 0) return [];
  if (n <= 4) return skillBoards.map((_, i) => i);

  const z = runnerZ + PRELOAD_M;

  let current = 0;
  for (let i = 0; i < n; i++) {
    if (skillBoards[i].z <= z) current = i;
    else break;
  }

  let start = current - 1;
  if (start < 0) start = 0;
  if (start > n - 4) start = n - 4;

  return [start, start + 1, start + 2, start + 3];
}

export function TunnelBoards({ fade = 1 }: { fade?: number }) {
  const runnerZ = useGameStore((s) => s.runnerZ);
  const walking = useGameStore((s) => s.tunnelWalking);

  const visible = useMemo(
    () => getVisibleBoardIndices(walking ? runnerZ : 0),
    [runnerZ, walking],
  );

  if (fade < 0.05) return null;

  return (
    <group>
      {visible.map((i) => {
        const board = skillBoards[i];
        return <SkillCard key={board.id} board={board} fade={fade} />;
      })}
    </group>
  );
}
